"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DeleteOne = exports.UpdateOne = exports.CreateOne = exports.GetOne = exports.GetAll = void 0;
function GetAll(baseUrl = 'https://trashable-server.herokuapp.com') {
    return __awaiter(this, void 0, void 0, function* () {
        const raw = yield window.fetch(`${baseUrl}/api/v1/trashcan`);
        if (!raw.ok) {
            throw new Error(yield raw.json());
        }
        const trashcans = (yield raw.json());
        return trashcans;
    });
}
exports.GetAll = GetAll;
function GetOne(id, baseUrl = 'https://trashable-server.herokuapp.com') {
    return __awaiter(this, void 0, void 0, function* () {
        const raw = yield window.fetch(`${baseUrl}/api/v1/trashcan/${id}`);
        const trashcan = (yield raw.json());
        return trashcan;
    });
}
exports.GetOne = GetOne;
function CreateOne(newTrashcan, token, baseUrl = 'https://trashable-server.herokuapp.com') {
    return __awaiter(this, void 0, void 0, function* () {
        const raw = yield window.fetch(`${baseUrl}/api/v1/trashcan`, {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                'auth-token': token,
            },
            body: JSON.stringify(newTrashcan),
        });
        const created = yield raw.json();
        return created;
    });
}
exports.CreateOne = CreateOne;
function UpdateOne(updatedTrashcan, id, token, baseUrl = 'https://trashable-server.herokuapp.com') {
    return __awaiter(this, void 0, void 0, function* () {
        const raw = yield window.fetch(`${baseUrl}/api/v1/trashcan/${id}`, {
            method: 'PUT',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                'auth-token': token,
            },
            body: JSON.stringify(updatedTrashcan),
        });
        const status = (yield raw.json());
        if (status.message === 'Executed correctly')
            status.succes = true;
        else
            status.succes = false;
        return status;
    });
}
exports.UpdateOne = UpdateOne;
function DeleteOne(updatedTrashcan, id, token, baseUrl = 'https://trashable-server.herokuapp.com') {
    return __awaiter(this, void 0, void 0, function* () {
        const raw = yield window.fetch(`${baseUrl}/api/v1/trashcan/${id}`, {
            method: 'DELETE',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                'auth-token': token,
            },
        });
        const status = (yield raw.json());
        if (status.message === 'Executed correctly')
            status.succes = true;
        else
            status.succes = false;
        return status;
    });
}
exports.DeleteOne = DeleteOne;
//# sourceMappingURL=index.js.map